<template>
	<div class="file-page" v-if="order">
		<div class="title-file">
			<p>Files</p>
		</div>

		<div class="main-session">
			<!-- first session -->
			<div class="first-session mt-2">
        <div v-for="(file,index) in files"
             :key="index">
          <div class="license mt-5" v-if="file['images'].length">
            <div>
              <div class="header-license">
                <p class="title-license" v-text="file['title']"></p>
                <div class="btn-camera">
                  <img class="pr-4" src="../../assets/images/Icon-upload-blue.svg" alt="upload-icon" />
                  <p class="text-plus">+</p>
                  <img src="../../assets/images/Camera-Icon-blue.svg" alt="" />
                </div>
              </div>
              <div class="departure-documents">
                <p class="text-created" v-text="file['static_text']"></p>
              </div>
              <div class="content-license mt-2">
                <a :href="dibbleJs.AnchorNoHandlerHref" v-for="(image, idx2) in file['images']"
                   :key="idx2"
                   :class="'images-viewer images-viewer-' + (index + '-' + idx2)" v-viewer="{movable: false}">
                  <img
                    :src="image"
                    alt=""
                    class="user-license-image"
                  />
                </a>
              </div>
            </div>
          </div>

          <div class="documents mt-5" v-if="file['alerts'].length">
            <div
              v-for="(alert, index) in file['alerts']"
              class="user-did-not-watch-video mb-3"
              :key="index"
            >
              <p v-text="file['title']"></p>
              <p class="text-active" v-text="alert"></p>
            </div>
          </div>
        </div>
			</div>

			<!-- second session -->
			<div class="second-session mt-2">
        <div v-if="checkoutImages.length">
          <p class="mt-5 title-session">Checkout images</p>
          <div class="checkout-imgs mt-2">
            <div class="content-img mt-3" v-for="(image, idx) in checkoutImages" :key="idx">
              <a :href="dibbleJs.AnchorNoHandlerHref" :class="'images-viewer images-viewer-' + (idx)" v-viewer="{movable: false}">
                <img
                  :src="image"
                  alt=""
                  class="user-license-image"
                />
              </a>
            </div>
          </div>
          <div class="line-through mt-5"></div>
        </div>

        <div v-if="checkinImages.length">
          <p class="mt-5 title-session">Checkin images</p>
          <div class="checkout-imgs mt-2">
            <div class="content-img mt-3" v-for="(image, idx) in checkinImages" :key="idx">
              <a :href="dibbleJs.AnchorNoHandlerHref" :class="'images-viewer images-viewer-' + (idx)" v-viewer="{movable: false}">
                <img
                  :src="image"
                  alt=""
                  class="user-license-image"
                />
              </a>
            </div>
          </div>
          <div class="line-through mt-5"></div>
        </div>

        <div v-if="checkinMarkingImages.length">
          <p class="mt-5 title-session">Checkin markings</p>
          <div class="checkout-imgs mt-2">
            <div class="content-img mt-3" v-for="(image, idx) in checkinMarkingImages" :key="idx">
              <a :href="dibbleJs.AnchorNoHandlerHref" :class="'images-viewer images-viewer-' + (idx)" v-viewer="{movable: false}">
                <img
                  :src="image"
                  alt=""
                  class="user-license-image"
                />
              </a>
            </div>
          </div>
          <div class="line-through mt-5"></div>
        </div>

        <div v-if="checkoutMarkingImages.length">
          <p class="mt-5 title-session">Checkout markings</p>
          <div class="checkout-imgs mt-2">
            <div class="content-img mt-3" v-for="(image, idx) in checkoutMarkingImages" :key="idx">
              <a :href="dibbleJs.AnchorNoHandlerHref" :class="'images-viewer images-viewer-' + (idx)" v-viewer="{movable: false}">
              <img
                :src="image"
                alt=""
                class="user-license-image"
              />
              </a>
            </div>
          </div>
          <div class="line-through mt-5"></div>
        </div>
			</div>

		</div>
	</div>
</template>

<script>
import {EventBus} from "@/utils/event-bus";
import DibbleAPI from "@/api";
import DibbleJS from "@/dibble";
import DibbleApi from "@/api";
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from "vue";

Vue.use(Viewer);
export default {
  name: 'OrderDetailFiles',
  data() {
    return {
      dibbleJs: DibbleJS,
      orderId: this.$route.params.id,
      order: null,
      files: [],

      checkoutImages: [],
      checkinImages: [],
      checkoutMarkingImages: [],
      checkinMarkingImages: [],
    };
  },
  created() {
    EventBus.$emit("currentViewOrderId", this.orderId);
    this.loadOrderInfo();
  },
  methods: {
    loadOrderInfo() {
      const params = {
        request: DibbleAPI.api.adminGetRentalBoatOrder,
        order_id: this.orderId
      }
      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, this._onLoadOrderSuccess, this._onLoadOrderFailed)
    },
    _onLoadOrderSuccess(response) {
      DibbleJS.hideLoader();
      if (DibbleApi.isResponseSuccess(response)) {
        this.order = response;

        this.files = this.order['files'];
        const checkoutImageFile = this.files.find(file => file['title'] === 'Checkout images');
        const checkinImageFile = this.files.find(file => file['title'] === 'Checkin images');
        const checkoutMarkingImageFile = this.files.find(file => file['title'] === 'Checkout markings');
        const checkinMarkingImageFile = this.files.find(file => file['title'] === 'Checkin markings');

        if (checkoutImageFile) {
          this.checkoutImages = checkoutImageFile['images'];
          this.files = this.files.filter(file => file['title'] !== 'Checkout images');
        }

        if (checkinImageFile) {
          this.checkinImages = checkinImageFile['images'];
          this.files = this.files.filter(file => file['title'] !== 'Checkin images');
        }

        if (checkoutMarkingImageFile) {
          this.checkoutMarkingImages = checkoutMarkingImageFile['images'];
          this.files = this.files.filter(file => file['title'] !== 'Checkout markings');
        }

        if (checkinMarkingImageFile) {
          this.checkinMarkingImages = checkinMarkingImageFile['images'];
          this.files = this.files.filter(file => file['title'] !== 'Checkin markings');
        }
      } else {
        DibbleJS.toastErrorMessage(response.message)
      }
    },
    _onLoadOrderFailed() {
      DibbleJS.hideLoader();
      DibbleJS.toastErrorMessage('Something wrong! can not load data');
    },
  }
};
</script>

<style lang="scss" scoped>
.file-page {
	margin: 20px 70px;
	padding: 20px;
	display: flex;
	flex-direction: column;
	user-select: none;
	min-width: 600px;
	background: #F3F6F7;
	box-shadow: 0px 15px 20px -6px rgba(16, 24, 40, 0.15);
	border-radius: 40px;

	p {
		font-family: "Open Sans";
		font-style: normal;
	}

	.title-file {
		display: flex;
		justify-content: space-between;

		p {
			font-weight: 600;
			font-size: 22px;
			color: #1c5169;
		}
	}

	.main-session {
		display: flex;

		.first-session {
			width: 50%;
			box-sizing: border-box;
			padding-right: 20px;

			.license {
				border-bottom: 1.5px solid #DEE6EA;
				padding-bottom: 20px;
			}

			.header-license {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.title-license {
					font-weight: 400;
					font-size: 20px;
					line-height: 24px;
					color: #555E67;
				}

				.btn-camera {
					display: flex;
					cursor: pointer;

					.text-plus {
						user-select: none;
						color: #2c94ab;
						padding-right: 3px;
						font-size: 20px;
						font-weight: bolder;
					}
				}
			}

			.content-license {
				width: 100%;
				min-height: 240px;
				background: #E8EFF1;
				box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
				border-radius: 30px;
			}

			.departure-documents {
				display: flex;
				flex-direction: column;
				padding-bottom: 20px;
				border-bottom: 1.5px solid #DEE6EA;

				.text-created {
					font-size: 20px;
					line-height: 24px;
					color: #555E67;
					font-weight: lighter;
				}
			}

			.documents {
				display: flex;
				justify-content: space-between;
				padding-bottom: 20px;
				border-bottom: 1.5px solid #DEE6EA;

				p {
					font-weight: 400;
					font-size: 20px;
					line-height: 24px;
					color: #555E67;
				}

				.text-active {
					font-weight: 600;
					font-size: 20px;
					color: #2C94AB;
				}
			}
		}

		.second-session {
			flex: 1;
			box-sizing: border-box;
			padding-left: 20px;

			.title-session {
				height: 30px;
				font-weight: 400;
				font-size: 20px;
				line-height: 24px;
				color: #555E67;
			}

			.checkout-imgs {
				width: 100%;
				box-sizing: border-box;
				padding: 30px 50px;
				background: #E8EFF1;
				box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
				border-radius: 30px;


				.content-img {
					background: #C2D8DD;
					border-radius: 40px;
					min-height: 220px;
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;

					img {
						max-width: 300px;
					}
				}
			}

			.line-through {
				height: 1.5px;
				background: #DEE6EA;
				width: 100%;
			}
		}
	}

  .user-license-image {
    max-width: 100%;
    border-radius: 5px;
  }

	@media only screen and (max-width: 1100px) {
		.main-session {
			flex-direction: column !important;
			.first-session {
				width: 100%;
				padding-right: 0px !important;
			}
			.second-session {
				padding-left: 0px !important;
			}
		}
	}
}
</style>
